
import axios from 'axios'
import { defineComponent } from 'vue'
import { enumToArray, payoutCurrencies as currencies } from '@/utils'
import { PaymentSystem } from '@/enums/PaymentSystem'
import { PaymentSystemNetwork } from '@/enums/PaymentSystemNetwork'
import { Currency } from '@/enums/Currency'
import { PayoutSystemAccount } from '@/store/types'

export default defineComponent({
  name: 'AddPaymentSystemDialog',
  props: ['open', 'close', 'refresh'],
  computed: {
    showDialog(): boolean {
      return this.open
    },
  },
  data: function() {
    return {
      payoutSystemAccount: {} as PayoutSystemAccount,
      paymentSystemsEnum: PaymentSystem,
      paymentSystemNetworks: enumToArray(PaymentSystemNetwork),
      paymentSystems: enumToArray(PaymentSystem).filter(
        e =>
          (e.id as any) !== PaymentSystem.QIWI &&
          (e.id as any) !== PaymentSystem.Capitalist &&
          (e.id as any) !== PaymentSystem.WebMoney,
      ),
      currencies,
      name: null,
      errors: {},
      loading: false,
    }
  },
  watch: {
    payoutSystemAccount: {
      handler() {
        if (
          (this.payoutSystemAccount as any).paymentSystem ===
            PaymentSystem.USDT ||
          (this.payoutSystemAccount as any).paymentSystem === PaymentSystem.USDC
        ) {
          ;(this.payoutSystemAccount as any).currency = Currency.USD
        }
      },
      deep: true,
    },
  },
  methods: {
    addPayoutAccount() {
      this.loading = true
      axios
        .post('/api/payout-system-accounts', { ...this.payoutSystemAccount })
        .then(() => {
          // this.$emit('refresh')
          this.onClose()
        })
        .catch(error => {
          this.errors = error.response.data.errors
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClose() {
      this.payoutSystemAccount = {} as PayoutSystemAccount
      this.errors = {}
      this.$emit('close')
      location.reload()
    },
  },
})
